import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasKits from './subabasKits';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useComponentesPaf } from '../../../../services/enum/useComponentesPaf';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useStatusKit } from '../../../../services/enum/useStatusKit';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import {
  getKitDeProduto,
  getProdutosDoKit,
} from '../../../../services/produtosDAF/kitProdutoService';
import { getProdutoDAFSimples } from '../../../../services/produtosDAF/produtosDafService';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../utils/swal';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;

type ProdutoOption = {
  value: number;
  label: string;
};

export default function KitsFicha() {
  //PERMISSOES
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Kits de Produtos')
      ?.value || '0',
  );

  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];
  const componenteAf = useComponentesPaf();
  const statusKit = useStatusKit();

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formKitProdutoInicial, setFormKitProdutoInicial] = useState<
    typeof formKitProduto | null
  >(null);
  const [produtosDoKitInicial, setProdutosDoKitInicial] = useState<
    ProdutoDoKit[] | null
  >(null);

  const [formKitProduto, setFormKitProduto] = useState({
    id: 0,
    usuarioId: userID,
    statusKit: 0,
    componenteAF: 0,
    nomeKit: '',
    descricao: '',
    observacoes: '',
  });

  // Estado para armazenar a lista de produtos e o estado de carregamento
  const [listaProdutosDAF, setListaProdutosDAF] = useState<ProdutoOption[]>([]); // Ajustado para o tipo { value, label }

  useEffect(() => {
    const fetchDataProdutosDaf = async () => {
      try {
        const produtos = await getProdutoDAFSimples();

        // Transforma os dados em formato { value, label } e adiciona "Não informado"
        const produtosFormatados: ProdutoOption[] = [
          { value: 0, label: 'Não informado' }, // Primeira opção padrão
          ...produtos.map((produto: any) => ({
            value: produto.id,
            label: produto.produtoFarmaceutico,
          })),
        ];

        setListaProdutosDAF(produtosFormatados); // Define a lista de produtos no estado com o tipo correto
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataProdutosDaf(); // Chama a função para buscar os dados
  }, []);

  //Buscar dados
  const fetchData = async (id: string) => {
    const kitProdutoData = await getKitDeProduto(id);

    // Atualizar o estado dos dados do kit
    const novoFormKitProduto = {
      id: kitProdutoData.id,
      usuarioId: userID,
      statusKit: kitProdutoData.statusKit,
      componenteAF: kitProdutoData.componenteAF,
      nomeKit: kitProdutoData.nomeKit,
      descricao: kitProdutoData.descricao,
      observacoes: kitProdutoData.observacoes,
    };
    setLogData(kitProdutoData);
    setFormKitProduto(novoFormKitProduto);
    setFormKitProdutoInicial(novoFormKitProduto); // Salvar o estado inicial

    try {
      const produtosDoKitData = await getProdutosDoKit(id);

      // Atualizar o estado dos produtos do kit com valores formatados
      const produtosFormatados = produtosDoKitData.map((produto: any) => ({
        usuarioId: userID,
        produtoDAFid: produto.produtoDAF.id,
        produtoDAF: produto.produtoDAF.produtoFarmaceutico,
        kitProdutoId: kitProdutoData.id,
        quantidade: produto.quantidade,
        observacoes: produto.observacoes || 'Nenhuma observação específica.',
      }));

      setProdutosDoKit(produtosFormatados);
      setProdutosDoKitInicial(produtosFormatados); // Salvar o estado inicial dos produtos
      setLinhas(produtosFormatados.map((_: any, index: number) => index));
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasKits(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/produtosdaf/kits/ficha/dadosgerais`,
      },
    ];
  }

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'componenteAF') {
      const newValue = parseInt(value, 10);
      setFormKitProduto({
        ...formKitProduto,
        componenteAF: newValue,
      });
    } else {
      setFormKitProduto((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusKit) {
      errors.push('<b>Status do Kit</b> é obrigatório.');
    }

    if (!form.componenteAF) {
      errors.push('<b>Componente AF</b> é obrigatório.');
    }

    if (!form.nomeKit) {
      errors.push('<b>Nome do Kit</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição do Kit</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    // Verificar se o formulário é válido
    const isFormValid = validateForm(formKitProduto);
    if (!isFormValid) return;

    const formToSend = {
      ...formKitProduto,
      statusKit: Number(formKitProduto.statusKit),
      componenteAF: Number(formKitProduto.componenteAF),
    };

    try {
      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/kitproduto/`, formToSend);

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `/#/daf/produtosdaf/kits/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    // Verificar se o formulário é válido
    const isFormValid = validateForm(formKitProduto);
    if (!isFormValid) return;

    const formToSend = {
      ...formKitProduto,
      statusKit: Number(formKitProduto.statusKit),
      componenteAF: Number(formKitProduto.componenteAF),
    };
    try {
      const response = await httpClient.patch(
        `/api/kitproduto/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registroAtualizado.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/kitproduto/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/produtosdaf/kits');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  const [linhas, setLinhas] = useState([0]); // Estado para controlar as linhas

  // Adiciona uma nova linha
  const handleInserirProduto = () => {
    setLinhas((prevLinhas) => [...prevLinhas, prevLinhas.length]);
    setProdutosDoKit((prevProdutos) => [
      ...prevProdutos,
      {
        usuarioId: userID,
        produtoDAFid: 0,
        produtoDAF: '',
        kitProdutoId: formKitProduto.id,
        quantidade: '',
        observacoes: '',
      },
    ]);
  };

  const handleRemoverProduto = () => {
    if (linhas.length > 1) {
      // Remover a última linha e atualizar os produtos
      setLinhas((prevLinhas) => prevLinhas.slice(0, -1));
      setProdutosDoKit((prevProdutos) => prevProdutos.slice(0, -1));
    } else {
      swalErro(
        'Não é possível remover. Pelo menos um produto deve estar presente.',
      );
    }
  };

  type ProdutoDoKit = {
    usuarioId: number;
    produtoDAFid: number;
    produtoDAF: string;
    kitProdutoId: number;
    quantidade: string | number;
    observacoes: string;
  };

  const [produtosDoKit, setProdutosDoKit] = useState<ProdutoDoKit[]>([
    {
      usuarioId: 0,
      produtoDAFid: 0,
      produtoDAF: '',
      kitProdutoId: 0,
      quantidade: '',
      observacoes: '',
    },
  ]);

  const handleChangeProduto = (
    event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
    index: number,
  ) => {
    const { value } = event.target;
    const produtoSelecionado = listaProdutosDAF.find(
      (produto) => produto.value === parseInt(value, 10),
    );

    if (!produtoSelecionado) {
      return; // Caso nenhum produto seja encontrado, não faça nada
    }

    // Verificar se o produto já foi selecionado em outra linha (excluindo a linha atual)
    const produtoJaSelecionado = produtosDoKit.some(
      (produto, idx) =>
        produto.produtoDAFid === produtoSelecionado.value && idx !== index,
    );

    if (produtoJaSelecionado) {
      // Se o produto já foi selecionado, exibir um erro e não fazer a atualização
      swalErro('Este produto já foi selecionado em outra linha.');
      return;
    }

    // Se não houver problema, prosseguir com a atualização
    const updatedProdutos = [...produtosDoKit];
    updatedProdutos[index] = {
      ...updatedProdutos[index],
      produtoDAFid: produtoSelecionado.value, // Atualiza o ID do produto selecionado
      produtoDAF: produtoSelecionado.label,
      kitProdutoId: formKitProduto.id,
    };
    setProdutosDoKit(updatedProdutos);
  };

  // Função para remover formatação e manter apenas números
  const handleChangeQuantidade = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const { value } = event.target;

    // Remover qualquer coisa que não seja dígito
    const rawValue = value.replace(/[^\d]/g, '');

    // Atualizar o valor no estado com o valor bruto, não formatado
    const updatedProdutos = [...produtosDoKit];
    updatedProdutos[index] = {
      ...updatedProdutos[index],
      quantidade: rawValue,
    };
    setProdutosDoKit(updatedProdutos);
  };

  // Função para aplicar a formatação ao perder o foco
  const handleBlurQuantidade = (index: number) => {
    const updatedProdutos = [...produtosDoKit];
    const quantidade = updatedProdutos[index].quantidade;

    if (typeof quantidade === 'string' && quantidade !== '') {
      // Converter para número e formatar com separadores de milhar
      const formattedValue = new Intl.NumberFormat('de-DE').format(
        Number(quantidade),
      );
      updatedProdutos[index] = {
        ...updatedProdutos[index],
        quantidade: formattedValue,
      };
      setProdutosDoKit(updatedProdutos);
    }
  };

  // Função auxiliar para formatar a quantidade para exibição
  const formatarQuantidadeParaExibir = (quantidade: string | number) => {
    if (typeof quantidade === 'string' && quantidade !== '') {
      return new Intl.NumberFormat('de-DE').format(Number(quantidade));
    }
    if (typeof quantidade === 'number') {
      return new Intl.NumberFormat('de-DE').format(quantidade);
    }
    return '';
  };

  const validateFormProduto = (produtos: typeof produtosDoKit) => {
    const errors: string[] = [];

    // Verificar cada produto no produtosDoKit
    produtos.forEach((produto, index) => {
      if (!produto.produtoDAFid || produto.produtoDAFid === 0) {
        errors.push(`Produto Farmacêutico não informado no item ${index + 1}.`);
      }

      if (!produto.quantidade) {
        errors.push(`Quantidade não informada no item ${index + 1}.`);
      }
    });

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleSalvarProdutos = async () => {
    // Verificar se o formulário é válido
    const isFormValid = validateFormProduto(produtosDoKit);
    if (!isFormValid) return;

    // Ajustar o formulário antes de enviar para o backend
    const adjustedForm = produtosDoKit.map((produto) => {
      let quantidadeFormatada = produto.quantidade;

      // Caso a quantidade seja uma string com separadores de milhar
      if (typeof quantidadeFormatada === 'string') {
        // Remover tudo que não seja dígito
        quantidadeFormatada = quantidadeFormatada.replace(/[^\d]/g, '');
      }

      // Converter para número
      const quantidadeNumerica = parseInt(String(quantidadeFormatada), 10);

      // Caso a conversão resulte em NaN, atribuir 0 como fallback
      return {
        usuarioId: Number(userID), // Garante que usuarioId seja incluído em todos os itens
        produtoDAFId: produto.produtoDAFid, // Ajusta o nome do campo para o esperado pelo backend
        kitProdutoId: produto.kitProdutoId, // Campo já está correto
        quantidade: isNaN(quantidadeNumerica) ? 0 : quantidadeNumerica, // Usa quantidadeNumerica ou 0
        observacoes: produto.observacoes || 'Nenhuma observação específica.', // Inclui observações padrão se estiver ausente
      };
    });

    // const token = 'JWT_SECRET';

    const response = await httpClient.post(
      `/api/kitprodutodafmanytomany/`,
      adjustedForm,
    );

    console.log('Produtos do Kit salvos com sucesso:', response.data);

    swalSave();
  };

  // Função para definir qual ação de salvar deve ser tomada
  const definirFuncaoSalvar = async () => {
    let houveMudancaKit = false;
    let houveMudancaProdutos = false;

    // Verificar se houve mudanças no form do kit
    if (formKitProdutoInicial) {
      houveMudancaKit =
        formKitProduto.statusKit !== formKitProdutoInicial.statusKit ||
        formKitProduto.componenteAF !== formKitProdutoInicial.componenteAF ||
        formKitProduto.nomeKit !== formKitProdutoInicial.nomeKit ||
        formKitProduto.descricao !== formKitProdutoInicial.descricao ||
        formKitProduto.observacoes !== formKitProdutoInicial.observacoes;
    } else {
      // Se formKitProdutoInicial é null, significa que é um novo registro
      houveMudancaKit = true;
    }

    // Verificar se houve mudanças nos produtos do kit
    if (produtosDoKitInicial) {
      if (produtosDoKitInicial.length !== produtosDoKit.length) {
        houveMudancaProdutos = true;
      } else {
        for (let i = 0; i < produtosDoKitInicial.length; i++) {
          if (
            produtosDoKitInicial[i].produtoDAFid !==
              produtosDoKit[i].produtoDAFid ||
            produtosDoKitInicial[i].quantidade !==
              produtosDoKit[i].quantidade ||
            produtosDoKitInicial[i].observacoes !== produtosDoKit[i].observacoes
          ) {
            houveMudancaProdutos = true;
            break;
          }
        }
      }
    } else {
      // Se produtosDoKitInicial é null, significa que são novos produtos
      houveMudancaProdutos = true;
    }

    // 1. Atualizar o Kit se houver mudanças
    if (houveMudancaKit) {
      if (formKitProdutoInicial && formKitProdutoInicial.id !== 0) {
        await handleUpdate();
      } else {
        await handleCreate();
      }

      // Atualizar o estado inicial do Kit após salvar
      setFormKitProdutoInicial(formKitProduto);
      houveMudancaKit = false; // Resetar o estado de verificação
    }

    // 2. Atualizar os produtos do Kit apenas se houver mudanças e o Kit já existir
    if (houveMudancaProdutos && formKitProduto.id !== 0) {
      await handleSalvarProdutos();

      // Atualizar o estado inicial dos produtos após salvar
      setProdutosDoKitInicial(produtosDoKit);
      houveMudancaProdutos = false; // Resetar o estado de verificação
    }
  };

  //Nível de Complexidade
  const [statusKitStyle, setStatusKitStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    const statusKit = Number(formKitProduto.statusKit);

    // Se o status não for informado (0)
    if (statusKit === 0) {
      setStatusKitStyle({ backgroundColor: '#ffffff' }); // Branco
      return;
    }

    if (statusKit === 1) {
      setStatusKitStyle({ backgroundColor: '#c7ffc3' });
      return;
    }

    if (statusKit === 2) {
      setStatusKitStyle({ backgroundColor: `#ffc6c6c0` });
      return;
    }
  }, [formKitProduto.statusKit]);

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/produtosdaf/kits"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />
          <BoxConteudo boxTitulo="Dados do Kit de Produtos">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="200px">
                <SelectInput
                  name="statusKit"
                  options={statusKit}
                  label="Status"
                  value={formKitProduto.statusKit}
                  onChange={handleChange}
                  style={statusKitStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="componenteAF"
                  options={componenteAf}
                  label="Componente AF"
                  value={formKitProduto.componenteAF}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="nomeKit"
                  value={formKitProduto.nomeKit}
                  id="nomeKit"
                  label="Nome do Kit"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="descricao"
                  value={formKitProduto.descricao}
                  id="descricao"
                  label="Descrição do Kit"
                  onChange={handleChange}
                  type="textarea"
                  linhas={3}
                  required
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Produtos do Kit">
            {produtosDoKit.map((produto, index) => (
              <CustomRow key={index}>
                <CustomCol width="100px">
                  <Input
                    id={`idProduto-${index}`}
                    name={`idProduto-${index}`}
                    label={`ID ${index + 1}`}
                    value={produto.produtoDAFid || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                    readonly
                  />
                </CustomCol>
                <CustomCol>
                  <SelectInput
                    name={`produtoDAF-${index}`}
                    options={listaProdutosDAF}
                    label={`Produto Farmacêutico ${index + 1}`}
                    value={produto.produtoDAFid || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                  />
                </CustomCol>
                <CustomCol width="200px">
                  <Input
                    name={`quantidade-${index}`}
                    value={formatarQuantidadeParaExibir(produto.quantidade)} // Formatando para exibição
                    id={`quantidade-${index}`}
                    label={`Quantidade por Kit ${index + 1}`}
                    onChange={(e) => handleChangeQuantidade(e, index)}
                    onBlur={() => handleBlurQuantidade(index)} // Aplica a formatação ao perder o foco
                    style={{ textAlign: 'right' }}
                  />
                </CustomCol>
              </CustomRow>
            ))}
            <CustomRow style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {fichaID === 'undefined' ? (
                <WorkspaceBotoes inserir inserirDisabled={true} />
              ) : (
                <WorkspaceBotoes
                  inserir
                  onClickInserir={handleInserirProduto}
                  remover
                  onClickRemover={handleRemoverProduto}
                />
              )}
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formKitProduto.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={definirFuncaoSalvar}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={definirFuncaoSalvar} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
